import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AddCategoryModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  isSaveButtonDisabled: boolean;
  categoryState: [any, React.Dispatch<React.SetStateAction<any>>];
  categories: any[];
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  open,
  handleClose,
  handleSave,
  isSaveButtonDisabled,
  categoryState,
  categories,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '720px',
      height: '370px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '32px 32px 32px 32px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: '656px',
      marginTop: '20px',
      background: '#FBFBFE',
      padding: '24px 24px',
      borderRadius: '8px',
    },
    selectFields: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '10px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants =
    componentConstants.ORGANISMS.CARE_NAV_MODALS.ADD_CATEGORY_MODAL;

  const [assignData, setAssignData] = categoryState;

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="4px 0px 10px 0px"
          >
            {constants.TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="24px"
            fontType="normal"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="4px 0px 10px 0px"
          >
            {constants.SUB_TITLE}
          </Typography>
        </Grid>

        <Grid container className={classes.inputFieldsGrid}>
          <Grid className={classes.selectFields}>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.CATEGORY}
                component={
                  <AutocompleteWithCheckBoxes
                    width="600px"
                    options={categories}
                    defaultValue={assignData.category}
                    handleChange={(event: any, value: any) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        category: value,
                      }));
                    }}
                    placeholder={
                      assignData.category.length === 0 ? 'Select' : ''
                    }
                    typable={true}
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            margin: '0px 0px 30px 390px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AddCategoryModal;
